import { createAction } from 'redux-actions';

export const ROItemOnClear = createAction('RO_ITEM_ON_CLEAR');

export const ROItemOnChangePage = createAction('RO_ITEM_ON_CHANGE_PAGE');

export const ROItemOnChangeOrder = createAction('RO_ITEM_ON_CHANGE_ORDER');

export const ROItemRemoveItem = createAction('RO_ITEM_REMOVE_ITEM');
